import React from 'react';

const ConfirmDialog = ({ show, onConfirm, onCancel }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-[100] p-4 animate-in fade-in duration-300">
      <div className="bg-white rounded-[2.5rem] p-8 shadow-2xl max-w-sm w-full mx-4 border border-gray-100 animate-in slide-in-from-bottom-4 duration-300">
        <h3 className="text-xl font-bold text-gray-900 text-center mb-2">Confirm Reservation</h3>
        <p className="text-gray-500 text-center mb-8 font-medium">Are you sure you want to approve this reservation? An email will be sent to the customer.</p>
        <div className="flex gap-4">
          <button
            className="flex-1 px-6 py-3 rounded-2xl bg-gray-50 text-gray-600 font-bold hover:bg-gray-100 transition-all text-sm"
            onClick={onCancel}
          >
            Go Back
          </button>
          <button
            className="flex-1 px-6 py-3 rounded-2xl bg-primary text-white font-bold shadow-lg shadow-primary/20 hover:scale-105 transition-all text-sm"
            onClick={onConfirm}
          >
            Approve
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
